export default __webpack_public_path__ + "static/media/radioCheckedIcon.668a22dc.svg";